// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SendNotePage_checkbox__bor73","navButtons":"SendNotePage_navButtons__3IRXp","previousMessagesContainer":"SendNotePage_previousMessagesContainer__nUSv1"};